import { CUBE_AGGREGATE_INTERACTION_PRODUCT } from '@/api/hcp/interaction/types';
import { buildInteractionIndicationFilter } from '@/models/filter/configs/channelSpecific/interactionIndicationFilter';
import { therapeuticIndicationDimensions } from '@/models/filter/utils/hierarchicalFilter';
import { LogicalAndFilter } from '@cubejs-client/core';
import { AdditionalFilterState } from './hooks';

export const appendInteractionIndicationFilter = (
  targetFilter: LogicalAndFilter,
  state: AdditionalFilterState,
  indicationOptionPaths: string[],
) => {
  if (!state?.interactionIndication?.length) return;

  const indicationFilter = buildInteractionIndicationFilter(
    state.interactionIndication,
    therapeuticIndicationDimensions(CUBE_AGGREGATE_INTERACTION_PRODUCT),
    undefined,
    indicationOptionPaths,
  );

  if (indicationFilter) {
    targetFilter.and.push(indicationFilter);
  }
};
